/*
 * (c) Copyright, 2025, Medidata Solutions Worldwide, Inc. All rights reserved.
 */

import React from 'react'
import { Field, FieldProps } from 'formik'
import { useServiceContext } from '../../../../../root'
import UserGroupSteps, { type StepConfig } from './UserGroupSteps'
import { WF_STEP_TYPE, type WfStepType } from './constants'

interface AuthorizationStepFormProps {
  values: {
    initialApprovers: {
      type: WfStepType
      steps: StepConfig[]
    }
  }
  setFieldValue: (field: string, value: any) => void
}

const AuthorizationStepForm: React.FC<AuthorizationStepFormProps> = ({ values, setFieldValue }) => {
  const context = useServiceContext()
  const { translate } = context.service.filter

  const initialApproversType = values.initialApprovers?.type || WF_STEP_TYPE.NOT_DEFINED

  return (
    <>
      <div className="form-group">
        <label className="control-label">
          {translate('BROWSER_FILE_SETTINGS_CR_APPROVERS_AUTHORIZATION_TYPE_HEADLINE')}
        </label>

        <Field name="initialApprovers.type">
          {({ field }: FieldProps) => (
            <>
              <div className="radio">
                <label>
                  <input
                    {...field}
                    type="radio"
                    id={`128af8c9-f439-41f2-9444-c8f436e128e0-${WF_STEP_TYPE.NOT_DEFINED}`}
                    value={WF_STEP_TYPE.NOT_DEFINED}
                    checked={initialApproversType === WF_STEP_TYPE.NOT_DEFINED}
                    onChange={() => setFieldValue('initialApprovers.type', WF_STEP_TYPE.NOT_DEFINED)}
                  />
                  {translate('BROWSER_FILE_SETTINGS_CR_APPROVERS_LABEL_NOT_DEFINED')}
                </label>
              </div>

              <div className="radio">
                <label>
                  <input
                    {...field}
                    type="radio"
                    id={`128af8c9-f439-41f2-9444-c8f436e128e0-${WF_STEP_TYPE.SETUP_WITH_WORKFLOW}`}
                    value={WF_STEP_TYPE.SETUP_WITH_WORKFLOW}
                    checked={initialApproversType === WF_STEP_TYPE.SETUP_WITH_WORKFLOW}
                    onChange={() => setFieldValue('initialApprovers.type', WF_STEP_TYPE.SETUP_WITH_WORKFLOW)}
                  />
                  {translate('BROWSER_FILE_SETTINGS_CR_APPROVERS_LABEL_SETUP_AUTHORIZERS_WITH_CR')}
                </label>
              </div>

              <div className="radio">
                <label>
                  <input
                    {...field}
                    type="radio"
                    id={`128af8c9-f439-41f2-9444-c8f436e128e0-${WF_STEP_TYPE.USE_PREDEFINED}`}
                    value={WF_STEP_TYPE.USE_PREDEFINED}
                    checked={initialApproversType === WF_STEP_TYPE.USE_PREDEFINED}
                    onChange={() => setFieldValue('initialApprovers.type', WF_STEP_TYPE.USE_PREDEFINED)}
                  />
                  {translate('BROWSER_FILE_SETTINGS_CR_APPROVERS_LABEL_USE_PREDEFINED')}
                </label>
              </div>
            </>
          )}
        </Field>
      </div>

      {/* Show UserGroupSteps when USE_PREDEFINED is selected */}
      {initialApproversType === WF_STEP_TYPE.USE_PREDEFINED && (
        <UserGroupSteps
          name="initialApprovers.steps"
          values={values.initialApprovers?.steps || []}
          labelTxt={'BROWSER_FILE_SETTINGS_CR_APPROVERS_APPROVAL_SEQUENCE_HEADLINE'}
          nofallTxt={'BROWSER_FILE_SETTINGS_CR_APPROVERS_INFO_LABEL'}
        />
      )}
    </>
  )
}

export default AuthorizationStepForm
